import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const StaticLogo = ({ logo, visible, scene }) => {
  return (
    <CSSTransitionGroup
      transitionName='co_logo'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={0}
    >
      {visible && <div id={`${scene > 1 ? 'co_splash__logo-' + scene : 'co_splash__logo'}`} className={`co_logo ${scene > 1 ? 'co_splash__logo-' + scene : 'co_splash__logo'}`} style={{ backgroundImage: `url(${logo})` }} key='logo' />}
    </CSSTransitionGroup>
  )
}

StaticLogo.propTypes = {
  logo: PropTypes.string,
  visible: PropTypes.bool,
  scene: PropTypes.number
}

export default StaticLogo



// WEBPACK FOOTER //
// ./src/templates/coffee/components/fixed/StaticLogo.js